import { ref } from 'vue'

const usePagination = () => {
  const currentPage = ref(1)
  const total = ref(0)
  const pageSize = ref(12)

  function setCurrentPage(_currentPage) {
    currentPage.value = _currentPage
  }

  function setPageSize(_pageSize) {
    pageSize.value = _pageSize
  }
  function setTotal(_total) {
    total.value = _total
  }

  return { currentPage, total, pageSize, setCurrentPage, setPageSize, setTotal }
}

export default usePagination
